import { Card, CardActions, CardContent, CardMedia, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

import MinesweeperImage from '../../assets/images/minesweeper.jpg'


const Minesweeper = ({ openMinesweeper, setOpenMinesweeper }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={MinesweeperImage}
          title='Minesweeper'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>Minesweeper</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenMinesweeper(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openMinesweeper}
        onClose={() => setOpenMinesweeper(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          Minesweeper
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={MinesweeperImage} alt='minesweeper' style={{
              width: 400,
              maxWidth: '100%',
              objectFit: 'contain'
            }} />
          </div>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            This is Minesweeper game implemented through ReactJS. Goal of this game is to uncover all cells that don't have a mine. You uncover cells by clicking on them with left mouse button. If cell is a mine, game is over and play again button is displayed. If cell is not a mine, then either number is revealed or cell remains empty. In case of number, that number tells how many mines are in adjacent cells and if there is no number that means that there is no mines in adjacent cells and they will be revealed automatically. With right mouse button you can place flag on cells that you think are mines. When there is a flag on the cell, that cell can no longer be left-clicked until you remove flag by right-clicking that field again.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }}>
            You can try the demo <a href='https://genuine-otter-49f3c5.netlify.app/' target="_blank" rel='noreferrer'><strong style={{ color: '#D1C7F0' }}>here</strong></a>.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Javascript</li>
              <li>React.js</li>
              <li>HTML</li>
              <li>CSS</li>
            </ul>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenMinesweeper(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Minesweeper